var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848075"
    },
    d: "M86.495,150.965v129.679l2.032,38.364c2.155,40.707,17.066,78.79,43.121,110.133l8.799,10.585 l0.248-0.457c31.464,32.625,73.037,49.041,114.682,49.286l62.247-191.932L255.377,76.054L86.495,150.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989487"
    },
    d: "M255.377,76.055v412.501c42.986,0.253,86.046-16.723,118.141-50.937 c31.554-33.637,50.879-78.882,50.879-128.644L255.377,76.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M350.653,406.239c-6.525-7.63-13.953-14.463-22.125-20.329 c-20.423-14.664-45.466-23.304-72.528-23.304c-27.063,0-52.104,8.639-72.528,23.304c-8.171,5.867-15.6,12.698-22.125,20.329 c-17.9,20.933-28.979,47.87-29.792,77.374c11.989,5.795,24.448,10.764,37.297,14.866c3.633,1.159,7.298,2.247,10.992,3.264 c0.486,0.133,0.971,0.264,1.458,0.395c23.816,6.419,48.853,9.864,74.697,9.864s50.881-3.445,74.697-9.864 c0.486-0.131,0.972-0.26,1.458-0.395c3.695-1.017,7.359-2.104,10.992-3.264c6.327-2.019,12.547-4.275,18.674-6.712 c3.74-1.488,7.455-3.026,11.115-4.666c2.521-1.129,5.026-2.288,7.508-3.488C379.631,454.109,368.551,427.172,350.653,406.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668BB7"
    },
    d: "M181.302,486.761c0-24.047,19.669-44.554,43.716-44.477c3.833,0.012,7.549,0.52,11.088,1.463 c1.311,0.349,2.627,0.662,3.949,0.941c7.889,1.662,15.322-4.313,15.322-12.375l0,0c0-6.329-4.669-11.756-10.951-12.533 c-24.542-3.035-46.127-15.598-60.954-33.869c-8.171,5.867-15.6,12.698-22.125,20.329c-17.9,20.933-28.979,47.869-29.792,77.374 c11.989,5.795,24.448,10.764,37.297,14.866c4.11,1.312,8.259,2.531,12.447,3.66c0.001-0.001,0.001-0.001,0.002-0.003v-15.035 L181.302,486.761L181.302,486.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M161.347,406.239c-17.9,20.933-28.979,47.87-29.792,77.374c11.989,5.795,24.448,10.764,37.297,14.866 c3.633,1.159,7.298,2.247,10.992,3.264c0.486,0.133,0.971,0.264,1.458,0.395v-21.26C181.302,453.689,174.037,428.2,161.347,406.239z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#55687D"
    },
    d: "M350.653,406.239c-3.452,5.975-6.497,12.214-9.109,18.674c-6.989,17.286-10.846,36.172-10.846,55.963 v21.26c0.486-0.131,0.972-0.26,1.458-0.395c3.695-1.017,7.359-2.104,10.992-3.264c6.327-2.019,12.547-4.275,18.674-6.712 c3.74-1.488,7.455-3.026,11.115-4.666c2.521-1.129,5.026-2.288,7.508-3.488C379.631,454.109,368.551,427.172,350.653,406.239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECCE93"
    },
    d: "M448.966,169.639c-9.132,0-17.745,2.199-25.363,6.075c-16.773-63.456-63.568-121.46-122.72-141.665 c-14.322-4.893-29.365-7.578-44.884-7.578c-79.621,0-146.768,70.424-167.604,149.244l76.109,198.31 c26.593,16.438,57.934,25.93,91.495,25.93c78.993,0,145.701-52.557,167.094-124.606c7.741,4.04,16.537,6.336,25.873,6.336 c30.941,0,56.023-25.082,56.023-56.023S479.907,169.639,448.966,169.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8E5B5"
    },
    d: "M392.944,206.988l-25.262,3.879h-37.348c0-14.358-5.61-27.837-15.796-37.955 c-10.211-10.141-46.725-15.727-61.182-15.727l0.024-0.037c-21.757-0.437-43.129-6.285-61.965-17.01 c-6.12-3.486-13.727-2.639-18.499,2.058l-0.687,0.682l-49.208,49.208c-3.646,3.646-8.426,5.47-13.204,5.47 c-4.778,0-9.559-1.823-13.204-5.47c-4.504-4.504-6.219-10.735-5.159-16.562l-3.055,0.189c-7.617-3.876-16.23-6.075-25.363-6.075 c-30.941,0-56.023,25.082-56.023,56.023s25.082,56.023,56.023,56.023c9.336,0,18.131-2.297,25.873-6.336 c12.304,41.438,39.599,76.424,75.598,98.676c18.453,4.712,36.812,7.256,54.147,7.256C314.91,381.28,392.944,303.247,392.944,206.988 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848075"
    },
    d: "M193.736,179.259c-6.794,0-13.582-1.073-20.181-3.222c-4.903-1.596-7.584-6.866-5.988-11.769 c1.597-4.905,6.873-7.585,11.77-5.988c9.416,3.066,19.388,3.064,28.835-0.005c4.901-1.594,10.172,1.089,11.765,5.994 c1.594,4.904-1.091,10.171-5.994,11.765C207.331,178.185,200.531,179.259,193.736,179.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848075"
    },
    d: "M318.231,179.259c-6.794,0-13.582-1.073-20.181-3.222c-4.903-1.596-7.584-6.866-5.988-11.769 c1.597-4.905,6.867-7.585,11.77-5.988c9.416,3.066,19.388,3.064,28.836-0.005c4.898-1.594,10.172,1.089,11.765,5.994 c1.594,4.904-1.091,10.171-5.994,11.765C331.825,178.185,325.026,179.259,318.231,179.259z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1C5D1"
    },
    d: "M167.343,252.071c-14.562-14.562-14.562-38.256,0-52.818c14.562-14.562,38.256-14.562,52.818,0 c14.562,14.562,14.562,38.256,0,52.818C205.599,266.633,181.905,266.633,167.343,252.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1C5D1"
    },
    d: "M291.838,252.071c-14.562-14.562-14.562-38.256,0-52.818c14.562-14.562,38.256-14.562,52.818,0 c14.562,14.562,14.562,38.256,0,52.818C330.094,266.633,306.4,266.633,291.838,252.071z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBEBE1"
    },
    d: "M291.838,199.253c-14.562,14.562-14.562,38.256,0,52.818l52.819-52.818 C330.094,184.691,306.4,184.691,291.838,199.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DBEBE1"
    },
    d: "M167.343,199.253c-14.562,14.562-14.562,38.256,0,52.818l52.819-52.818 C205.599,184.691,181.905,184.691,167.343,199.253z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E474C"
    },
    d: "M318.247,178.976c-16.422,0-30.881,8.532-39.206,21.387c-6.087-5.549-14.176-8.937-23.042-8.937 c-8.865,0-16.955,3.389-23.042,8.937c-8.324-12.855-22.783-21.387-39.206-21.387c-12.227,0-23.364,4.731-31.696,12.449H127.77 c-1.717,0-3.112-1.397-3.112-3.112c0-5.157-4.179-9.337-9.337-9.337c-5.158,0-9.337,4.181-9.337,9.337 c0,12.012,9.774,21.787,21.787,21.787h21.973c-1.728,4.87-2.677,10.106-2.677,15.562c0,25.743,20.943,46.686,46.686,46.686 s46.686-20.943,46.686-46.686c0-8.581,6.98-15.562,15.562-15.562s15.562,6.98,15.562,15.562c0,25.743,20.943,46.686,46.686,46.686 c25.743,0,46.686-20.943,46.686-46.686S343.99,178.976,318.247,178.976z M193.752,253.673c-15.445,0-28.011-12.565-28.011-28.011 s12.566-28.011,28.011-28.011s28.011,12.565,28.011,28.011S209.197,253.673,193.752,253.673z M318.247,253.673 c-15.445,0-28.011-12.565-28.011-28.011s12.566-28.011,28.011-28.011c15.445,0,28.011,12.565,28.011,28.011 S333.692,253.673,318.247,253.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD7155"
    },
    d: "M269.694,272.347h-27.389c-5.158,0-9.337-4.181-9.337-9.337c0-5.157,4.179-9.337,9.337-9.337h27.389 c5.158,0,9.337,4.181,9.337,9.337C279.031,268.167,274.852,272.347,269.694,272.347z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ECCE93"
    },
    cx: 63.032,
    cy: 225.659,
    r: 18.674
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1B872"
    },
    cx: 448.965,
    cy: 225.659,
    r: 18.674
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989487"
    },
    d: "M424.397,308.975V128.304c0-32.972-15.839-64.346-42.369-83.927C343.252,15.761,295.019,0,246.212,0 c-43.847,0-86.323,12.32-122.838,35.629c-8.896,5.681-14.657,14.957-15.802,25.452c-1.036,9.506,1.785,18.763,7.945,26.065 l1.287,1.528l0.804,0.387l-4.549,3.456c-34.958,26.554-25.52,58.448-25.52,78.922l1.012,4.186l10.06,5.103 c1.386,0.701,2.939,1.071,4.492,1.071c2.665,0,5.169-1.04,7.039-2.916l50.01-50.003c6.319-6.222,14.733-9.648,23.69-9.648 c4.439,0,8.825,0.876,12.889,2.557c1.325,0.548,2.614,1.181,3.862,1.897c16.882,9.701,36.153,14.83,55.774,14.83l1.315-0.005 c19.421,0,37.68,7.512,51.413,21.152c13.743,13.65,21.311,31.835,21.311,51.203v173.682 C330.404,384.548,393.604,367.545,424.397,308.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989487"
    },
    d: "M107.57,61.081c0.095-0.87,0.233-1.728,0.391-2.581C107.804,59.353,107.666,60.211,107.57,61.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#989487"
    },
    d: "M108.078,57.906c0.171-0.837,0.36-1.667,0.589-2.484C108.438,56.238,108.248,57.068,108.078,57.906z "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ADA999"
    },
    d: "M246.212,18.674c-25.155,0-49.812,4.41-72.943,12.93c-3.109,1.145-6.961,2.873-11.079,4.883 c-13.732,6.697-13.069,26.5,1.048,32.34l40.626,16.804c2.063,0.853,4.092,1.85,6.033,2.965c0.097,0.056,0.194,0.111,0.291,0.167 c15.904,9.061,35.963,6.07,48.907-6.873l30.428-30.428c10.192-10.192,4.651-27.756-9.579-30.062 C268.822,19.597,257.534,18.674,246.212,18.674z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#848075"
    },
    d: "M309.093,140.763c-13.733-13.641-31.991-21.152-51.413-21.152l-1.315,0.005 c-19.62,0-38.892-5.128-55.774-14.83c-1.246-0.716-2.537-1.35-3.862-1.897l-79.123-32.727l0,0l-0.804-0.387l-1.287-1.528 c-3.226-3.824-5.525-8.188-6.846-12.839c-0.517,1.84-0.888,3.735-1.099,5.673c-1.036,9.506,1.787,18.763,7.945,26.065l1.287,1.528 l0.804,0.387l0,0l-4.549,3.456c-34.958,26.554-25.52,58.448-25.52,78.922l1.012,4.186l10.06,5.103 c1.386,0.701,2.939,1.071,4.492,1.071c2.665,0,5.169-1.04,7.039-2.916l50.01-50.003c6.319-6.222,14.733-9.648,23.69-9.648 c4.439,0,8.825,0.876,12.89,2.557c1.325,0.548,2.614,1.181,3.862,1.897c16.882,9.701,36.153,14.83,55.774,14.83l1.315-0.005 c19.421,0,37.68,7.512,51.413,21.152c13.743,13.65,21.311,31.835,21.311,51.203v-18.9 C330.404,172.597,322.836,154.412,309.093,140.763z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M362.744,423.011c1.784,2.965,3.449,6.011,4.986,9.129 C366.192,429.02,364.529,425.975,362.744,423.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M376.688,485.357c1.251-0.581,2.514-1.144,3.755-1.744c-0.102-3.688-0.364-7.336-0.779-10.937 c0.416,3.602,0.677,7.249,0.779,10.937C379.202,484.213,377.941,484.777,376.688,485.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M376.779,456.809c1.292,5.168,2.262,10.465,2.885,15.867 C379.041,467.274,378.072,461.978,376.779,456.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M367.73,432.14c1.538,3.119,2.948,6.312,4.225,9.571C370.679,438.452,369.267,435.259,367.73,432.14 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5D7A9A"
    },
    d: "M266.049,363.006c4.972,0.397,9.861,1.087,14.651,2.052 C275.91,364.093,271.02,363.404,266.049,363.006z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668BB7"
    },
    d: "M207.736,372.322c0.112-0.047,0.22-0.098,0.332-0.146 C207.958,372.222,207.848,372.274,207.736,372.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#668BB7"
    },
    d: "M212.361,370.479c0.039-0.015,0.077-0.031,0.116-0.045 C212.437,370.449,212.4,370.466,212.361,370.479z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.2f5bcb836ff8ff72c167bdb5f36651a9.svg";
export { ForwardRef as ReactComponent };